import React, { useEffect, useState } from 'react'
import TransferWithCheckbox from 'components/ExportTransfer/TransferWithCheckbox'
import { Button } from 'antd'
import styled from 'styled-components'

const ExportFormats = styled.div`
  font-family: 'Plus Jakarta Sans';
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  color: #000000;
  margin-top: 10px;
  float: right;
  margin-right: -70px;
`

const CustomReport = ({
  setExported,
  customerReportDataList,
  setShowDrawer,
  setState,
  state,
  customState,
  setCustomState,
}) => {
  const [selectedKeys, setSelectedKeys] = useState([])
  const [data, setData] = useState([])

  const defaultDataSetup = async () => {
    let listData = await customerReportDataList()
    listData = listData?.map((item, index) => ({
      key: (index + 1)?.toString(),
      title: item,
    }))

    if (listData?.length) {
      setData(listData)
    }
  }

  useEffect(() => {
    defaultDataSetup()
  }, [])

  useEffect(() => {
    const selectedtTitles = []
    selectedKeys?.map(item => {
      data.map(dataItem => {
        if (dataItem?.key === item) {
          selectedtTitles.push(dataItem?.title)
        }
      })
    })
    setState({
      ...state,
      downloadList: selectedtTitles,
    })
  }, [selectedKeys])

  const handleExport = () => {
    // setExported(true)
    setShowDrawer(true)
    setCustomState(true)
  }

  return (
    <>
      <div style={{ padding: '20px' }}>
        <TransferWithCheckbox data={data} onChange={setSelectedKeys} />
        <Button
          type="primary"
          onClick={handleExport}
          disabled={selectedKeys.length === 0}
          style={{ marginTop: '20px', float: 'right' }}
        >
          Export
        </Button>
        <br></br>
        <br></br>
        <ExportFormats>Excel / CSV / Google Sheet</ExportFormats>
      </div>
    </>
  )
}

export default CustomReport
